var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.$route.params.withdraw == 'pay')?[_c('img',{attrs:{"width":"30%","src":"static/assets/img/jeton-kart.png"}}),_vm._v(" "),_c('jetonForm'),_vm._v(" "),_c('h4',{staticClass:"mt-2"},[_vm._v("Güncel Jeton hesaplarımızı lütfen Canlı Destek üzerinden isteyiniz.")])]:_vm._e(),_vm._v(" "),(_vm.$route.params.withdraw == 'withdraw')?[_c('jetonWithdraw')]:_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-72d69b18","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/payments/gateways/jeton.vue
// module id = JwDA
// module chunks = 0